// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".formMenuList{z-index:999;position:absolute;bottom:6rem;right:3rem;width:40%;min-width:220px;background:#fff;border-radius:1rem;padding:.5rem}", ""]);
// Exports
module.exports = exports;
